import { FaEnvelope, FaFacebookF, FaInstagram, FaMapMarkerAlt, FaPhoneAlt, FaYoutube } from 'react-icons/fa';
import {
  ContactIcon,
  ContactItem,
  Copyright,
  FooterContainer,
  FooterContent,
  FooterLink,
  FooterSection,
  FooterTitle,
  QuickLinksGrid,
  SocialIcon,
  SocialLinks
} from './styles/Footer.styles';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>Fussaki Charters</FooterTitle>
          <p>Premium spearfishing and sportfishing charters out of San Pedro, CA. Captain-led trips targeting White Seabass, Yellowtail, Bluefin Tuna, and more across Southern California's best waters.</p>
          <SocialLinks>
            <SocialIcon href="https://www.instagram.com/fussaki/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              {FaInstagram({ size: 18 })}
            </SocialIcon>
            <SocialIcon href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              {FaFacebookF({ size: 16 })}
            </SocialIcon>
            <SocialIcon href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              {FaYoutube({ size: 18 })}
            </SocialIcon>
          </SocialLinks>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Quick Links</FooterTitle>
          <QuickLinksGrid>
            <FooterLink to="/">Home</FooterLink>
            <FooterLink to="/gallery">Gallery</FooterLink>
            <FooterLink to="/about">About</FooterLink>
            <FooterLink to="/book">Book Now</FooterLink>
            <FooterLink to="/charters">Charters</FooterLink>
            <FooterLink to="/contact">Contact</FooterLink>
          </QuickLinksGrid>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Contact Info</FooterTitle>
          <ContactItem>
            <ContactIcon>
              {FaPhoneAlt({ size: 16 })}
            </ContactIcon>
            <span>(714) 200-9815</span>
          </ContactItem>
          <ContactItem>
            <ContactIcon>
              {FaEnvelope({ size: 16 })}
            </ContactIcon>
            <span>fussaki@gmail.com</span>
          </ContactItem>
          <ContactItem>
            <ContactIcon>
              {FaMapMarkerAlt({ size: 16 })}
            </ContactIcon>
            <span>224 Whalers Walk, San Pedro, CA 90731</span>
          </ContactItem>
        </FooterSection>
      </FooterContent>
      
      <Copyright>
        &copy; {new Date().getFullYear()} Fussaki Spearfishing & Sportfishing Charters. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
